// ── Belső linkek záró perjellel (audit 2026-10-26, #6) ───────────────────────
//
// A prerenderelt oldalak KÖNYVTÁRKÉNT léteznek (/szerviz/index.html), ezért az
// nginx a perjel nélküli címet 301-gyel a perjeles alakra irányítja. A belső
// linkek a perjeles alakra mutatnak, hogy ne legyen fölösleges átirányítás.
//
// CSAK olyan célhoz teszünk perjelt, amit az nginx perjellel is kiszolgál:
//   - a statikusan prerenderelt útvonalak (constants/prerenderUtvonalak.mjs),
//   - az /osszehasonlitas/<pár>, /telefonok/<uid>, /blog/<slug> aloldalak
//     (ezeket az nginx regex-szel ismeri, akkor is, ha épp nincs kész HTML),
//   - maga az /osszehasonlitas index.
// Minden más (SEO-alias, /nyitva, /hivtal, átirányító csonkok) VÁLTOZATLAN
// marad: ott a perjeles alak az nginx-ben valódi 404 lenne.

import { PRERENDER_UTVONALAK } from '../constants/prerenderUtvonalak.mjs';

const PERJELES = new Set([...PRERENDER_UTVONALAK, '/osszehasonlitas']);
const DINAMIKUS = /^\/(osszehasonlitas|telefonok|blog)\/[^/]+$/;
const FAJL = /\.[a-z0-9]{2,5}$/i;

/** Belső útvonal záró perjellel, ha a cél perjellel is kiszolgált oldal.
 *  A query (?…) és a hash (#…) megmarad; külső URL, fájl, már perjeles
 *  útvonal és ismeretlen cél változatlanul jön vissza. */
export const withSlash = (href) => {
  if (typeof href !== 'string' || !href.startsWith('/') || href.startsWith('//')) return href;
  const m = href.match(/^([^?#]*)(.*)$/);
  const ut = m[1];
  const maradek = m[2];
  if (ut === '/' || ut.endsWith('/') || FAJL.test(ut)) return href;
  if (!PERJELES.has(ut) && !DINAMIKUS.test(ut)) return href;
  return `${ut}/${maradek}`;
};

/** Abszolút URL a norbiphone.hu-n, ugyanazzal a szabállyal (JSON-LD-hez). */
export const SITE = 'https://norbiphone.hu';
export const absUrl = (path) => (path === '/' ? `${SITE}/` : `${SITE}${withSlash(path)}`);

/** A kanonikus URL a ténylegesen kiszolgált, ZÁRÓ PERJELES alak.
 *  A query/hash rész sértetlen marad (`#belvaros` horgonyok az /uzletek-en).
 *  A gyökér (`https://norbiphone.hu`) is perjelet kap – az is így szolgálódik. */
export const withTrailingSlash = (u) => {
  if (typeof u !== 'string' || !u) return u;
  const cut = u.search(/[?#]/);
  const base = cut === -1 ? u : u.slice(0, cut);
  const rest = cut === -1 ? '' : u.slice(cut);
  return (base.endsWith('/') ? base : `${base}/`) + rest;
};
